/** ----------------------------------------
     Imports
 ---------------------------------------- */

import errors from '@router/routes/errors';

/** ----------------------------------------
    Front routes
 ---------------------------------------- */

const routes = [
    {
        path: '',
        redirect: '/home',
        component: () => import('@view/layout/Master.vue'),
        children: [
            {
                name: 'home',
                path: '/',
                component: () => import('@view/templates/Home.vue'),
            },
            {
                name: 'page',
                path: '/page/:id/:slug',
                component: () => import('@view/templates/Page.vue'),
                props: true,
                scrollBehavior: false
            },
            {
                name: 'work',
                path: '/work',
                component: () => import('@view/templates/Work.vue')
            },
            {
                name: 'case',
                path: '/case/:id/:slug',
                component: () => import('@view/templates/Case.vue'),
                scrollBehavior: false
            },
            {
                name: 'news',
                path: '/news/:id/:slug',
                component: () => import('@view/templates/News.vue'),
                scrollBehavior: false
            },
            {
                name: 'team',
                path: '/team',
                component: () => import('@view/templates/Team.vue')
            },
            {
                name: 'jobs',
                path: '/jobs',
                component: () => import('@view/templates/Jobs.vue')
            },
            {
                name: 'about',
                path: '/about',
                component: () => import('@view/templates/About.vue')
            },
            {
                name: 'contact',
                path: '/contact',
                component: () => import('@view/templates/Contact.vue')
            }
        ]
    },
    ...errors
];

/** ----------------------------------------
    Export Modules
 ---------------------------------------- */

export default routes;